<div [class]="notificationItemClasses">
  <div class="notification-icon">
    @if (!hasImage) {
      <div class="icon-wrapper">
        <icon-display [iconName]="'bell-unfilled'" />
      </div>
    }
    @if (hasImage) {
      <img
        class="profile-pic"
        alt="Notification image"
        width="40"
        height="40"
        [ngSrc]="notificationImage" />
    }
  </div>

  <div class="notification-data">
    <div class="notification-title">{{ notificationTitle }}</div>
    <div class="notification-message">{{ notificationBody }}</div>
    <div class="notification-date">{{ notificationDate }}</div>
  </div>

  <div class="unread-indicator"></div>
</div>
